import { type MarkerRouteProps } from './types';
import { Marker as MapMarker, Circle } from 'react-naver-maps';
import type { MarkerProps } from './types';
import { renderToString } from 'react-dom/server';
import { type StaticImageData } from 'next/image';
import { Polyline } from 'react-naver-maps';
import { MapPinPointAtom } from '~/components/Atoms/MapPinPointAtom/MapPinPointAtom';
import GraphicFaceYellow from '@public/Assets/Icons/GraphicYellowHeartSmileWhite.svg';

export const Marker = ({
  icon,
  range,
  coordinates,
  fillColor,
  strokeColor,
  ...props
}: MarkerProps) => {
  return (
    <>
      <MapMarker
        cursor="pointer"
        icon={icon}
        position={new naver.maps.LatLng(coordinates.lat, coordinates.long)}
        {...(props ?? {})}
        zIndex={2}
      />
      {range ? (
        <Circle
          center={new naver.maps.LatLng(coordinates.lat, coordinates.long)}
          radius={100}
          fillColor={fillColor ?? '#fff56640'}
          strokeColor={strokeColor ?? '#00000000'}
          zIndex={1}
        />
      ) : null}
    </>
  );
};

export const MapDirection = ({ start, path, end }: MarkerRouteProps) => {
  return (
    <>
      <Marker
        zIndex={20}
        {...start}
        icon={{
          size: new naver.maps.Size(24, 24),
          anchor: new naver.maps.Point(16, 16),
          content: renderToString(<MapPinPointAtom type="Circle" />),
        }}
      />
      <Marker
        zIndex={20}
        {...end}
        icon={{
          size: new naver.maps.Size(48, 54),
          anchor: new naver.maps.Point(24, 50),
          content: renderToString(
            <MapPinPointAtom
              image={GraphicFaceYellow as StaticImageData}
              type="YellowLocation"
            />,
          ),
        }}
      />
      <Polyline
        endIcon={naver.maps.PointingIcon.CIRCLE}
        startIcon={naver.maps.PointingIcon.CIRCLE}
        strokeColor="#FFEC3D"
        strokeWeight={4}
        path={path.map(el => new naver.maps.LatLng(el[1], el[0]))}
      />
    </>
  );
};
